
export interface AjaxCallback {
  (data: any): void;
}

export interface AjaxFailureCallback {
  (status: number, data: any): void;
}

interface AjaxParams {
  method: string;
  path: string;
  cb: AjaxCallback;
  body?: FormData | Object;
  failure_cb?: AjaxFailureCallback;
}

export class Ajax {

  static csrf: string | null = null;

  static getCSRFToken(doc: Document): string | null {
    if (!doc.head) {
      return null;
    }
    const meta = doc.head.querySelector('meta[name="csrf.token"]') as HTMLMetaElement;
    if (meta !== null) {
      return meta.content;
    }
    return null;
  }

  static setCSRFHeader(r: XMLHttpRequest) {
    if (!Ajax.csrf) {
      Ajax.csrf = Ajax.getCSRFToken(document);
    }
    if (Ajax.csrf) {
      r.setRequestHeader("X-CSRF-Token", Ajax.csrf);
    }
  }

  static get(path: string, cb: AjaxCallback, failure_cb?: AjaxFailureCallback) {
    Ajax.perform({ method: "GET", path: path, cb: cb, body: undefined, failure_cb: failure_cb });
  }

  static put(path: string, cb: AjaxCallback, body?: FormData | Object, failure_cb?: AjaxFailureCallback) {
    Ajax.perform({ method: "PUT", path: path, cb: cb, body: body, failure_cb: failure_cb });
  }

  static post(path: string, cb: AjaxCallback, body?: FormData | Object, failure_cb?: AjaxFailureCallback) {
    Ajax.perform({ method: "POST", path: path, cb: cb, body: body, failure_cb: failure_cb });
  }

  static delete(path: string, cb: AjaxCallback, failure_cb?: AjaxFailureCallback) {
    Ajax.perform({ method: "DELETE", path: path, cb: cb, body: undefined, failure_cb: failure_cb });
  }

  static perform(params: AjaxParams): void {
    const request = new XMLHttpRequest();
    request.open(params.method, params.path, true);
    Ajax.setCSRFHeader(request);

    let retry_count = 0;

    request.onload = function () {
      let ct = request.getResponseHeader("content-type");
      const json = ct && ct.indexOf('json') > -1;
      let data = request.responseText;
      if (json) {
        try {
          data = JSON.parse(request.responseText);
        } catch (error) {
          // no-op
        }
      }
      if (request.status >= 200 && request.status < 400) {
        params.cb(data);
      } else if (params.failure_cb !== undefined) {
        const fail_cb = params.failure_cb;
        if (request.status === 403 && retry_count < 2) {
          retry_count++;
          console.log("403, updating csrf");
          const r = new XMLHttpRequest();
          r.open("GET", "/", true);

          // reset the token on load and retry the request
          r.onload = function () {
            try {
              const p = new DOMParser();
              const doc = p.parseFromString(r.responseText, "text/html");
              Ajax.csrf = Ajax.getCSRFToken(doc);
              send();
            } catch (ex) {
              console.log(ex);
            }
          }

          // just call the original fail cb on error
          r.onerror = function () {
            fail_cb(request.status, data);
          }
          r.send();
        } else {
          fail_cb(request.status, data);
        }
      }
    };

    request.onerror = function () {
      console.log(request.status, request);
      if (params.failure_cb !== undefined) {
        params.failure_cb(request.status, request.responseText);
      }
    };

    const send = function () {
      if (params.body instanceof FormData) {
        request.send(params.body);
      } else if (params.body instanceof Object) {
        request.setRequestHeader("Content-Type", "application/json");
        request.send(JSON.stringify(params.body));
      } else {
        request.send();
      }
    }
    send();
  }
}